<template>
  <d-card class="card-small h-100">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
      <div class="block-handle"></div>
    </d-card-header>

    <d-card-body class="pt-0">
      <!-- Legend & Chart -->
      <div ref="legend"></div>
      <vue-funnel-graph
        :width="chartData.width"
        :height="chartData.height"
        :labels="chartData.labels"
        :values="chartData.values"
        :colors="chartData.colors"
        :sub-labels="chartData.subLabels"
        :direction="chartData.direction"
        :gradient-direction="chartData.gradientDirection"
        :animated="true"
        :display-percentage="true"
      ></vue-funnel-graph>
    </d-card-body>
  </d-card>
</template>

<script>
import { VueFunnelGraph } from "vue-funnel-graph-js";

const defaultChartData = {
  labels: ["Impressions", "Add To Cart", "Buy"],
  subLabels: ["Direct" /*, "Social Media", "Ads"*/],
  values: [
    // with the given Labels and SubLabels here's what the values represent:
    //
    // Direct, Social, Ads
    //    |      |     |
    //    v      v     v
    [3000 /*, 2500, 6500*/], // Segments of "Impressions" from top to bottom
    [1000 /*, 1700, 1000*/], // Segments of "Add To Cart"
    [10 /*, 200, 130*/] // Segments of "Buy"
  ],
  colors: [
    ["#FFB178", "#FF3C8E"], // color set for "Impressions" segment
    ["#A0BBFF", "#EC77FF"], // color set for "Add To Cart" segment
    ["#A0F9FF", "#7795FF"] // color set for "Buy" segment
  ],
  direction: "horizontal",
  gradientDirection: "horizontal",
  height: 300,
  width: 800
};

export default {
  name: "users-overview",
  components: {
    VueFunnelGraph
  },
  props: {
    title: {
      type: String,
      default: "supporters Overview"
    },
    chartData: {
      type: Object,
      default() {
        return defaultChartData;
      }
    }
  },
  data() {
    return {
      dateRange: {
        from: null,
        to: null
      }
    };
  },
  mounted() {}
};
</script>
